// TODO: Add option to get SVG as a prop to show that as the content loader
// TODO: Add storybook entry for this particular component

import React from "react";
import ContentLoader from "react-content-loader";
import PropTypes from "prop-types";

/*
 * Loader
 ** This component uses react-content-loader to show loading animation
 ** We can pass an animation type for react-content-loader or an SVG
 ** This is a wrapper component and the content that needs to be shown when loading is completed should be passed as children
 */

// List of default content loaders that React-Content-Loader provides
const DEFAULT_CONTENT_LOADERS = [
  "list", // Used as the Animation type default
  "code",
  "facebook",
  "instagram",
  "bullet-list",
];

export const Loader = ({
  isLoading, // Loading status that determines what to show, loader or children
  animationType, // Type of animation to display if there is no SVG
  animationSvg, // SVG that can be used as the loading animation
  animationSpeed, // Speed at which the animation runs
  children, // The component that needs to displayed after loading is done
}) => {
  return isLoading
    ? animationSvg
      ? renderSvgLoadingState({ animationSvg, animationSpeed })
      : renderLoadingState({ animationType, animationSpeed })
    : renderChildren({ children });
};

const renderLoadingState = ({ animationType, animationSpeed }) => {
  return <ContentLoader type={animationType} speed={animationSpeed} />;
};

// TODO: Need to update to use SVG
const renderSvgLoadingState = () => {
  return (
    <>
      <ContentLoader
        speed={2}
        width={1200}
        height={688}
        viewBox="0 0 713 688"
        backgroundColor="#003e6b"
        // foregroundColor='#275c83'>
        foregroundColor="#3997dc"
      >
        <rect x="2" y="117" rx="3" ry="3" width="1200" height="340" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={2000}
        height={300}
        viewBox="0 0 713 688"
        backgroundColor="#003e6b"
        // foregroundColor='#275c83'>
        foregroundColor="#3997dc"
      >
        <rect x="2" y="0" rx="3" ry="3" width="2000" height="300" />
      </ContentLoader>
    </>
  );
};

const renderChildren = ({ children }) => {
  return <>{children}</>;
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
  animationType: PropTypes.oneOf(DEFAULT_CONTENT_LOADERS),
  animationSvg: PropTypes.any,
  animationSpeed: PropTypes.number,
  children: PropTypes.element.isRequired,
};

Loader.defaultProps = {
  isLoading: false,
  animationType: DEFAULT_CONTENT_LOADERS[0],
  animationSpeed: 2,
};
